const fireGTMEvent = (eventName: string, cb: () => void) => {
    window.dataLayer?.push({
        event: eventName,
        eventCallback: cb,
    });
};

export const fireDemoRequestSuccessEvent = (callback?: () => void) => {
    if (!window.dataLayer) {
        callback?.();
    }

    // If GTM events are not fired within 10 seconds, redirect to thank you page anyway
    // since form submission still completed
    const redirectTimeout = 10000; // 10 seconds
    const timeout = setTimeout(() => {
        callback?.();
    }, redirectTimeout);
    fireGTMEvent('demoRequestSuccess', () => {
        clearTimeout(timeout);
        callback?.();
    });
};
